<div class="row m-0 bg-black">
    <div class="col-12 p-0">
        <div class="container px-5 header py-3 d-flex justify-content-between">
            <img src="./assets/images/Logo.png" class="w-auto pointer" alt="Logo" routerLink="/">
            <!-- <div> -->
                <div ngbDropdown class="d-inline-block">
                    <img src="../../../assets/images/User Icon.svg" class="h-75 pointer" alt="" id="dropdownBasic1"
                        ngbDropdownToggle>
                    <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="align-content-center">
                        <!--<a ngbDropdownItem class="ff-semibold">
                            My Account
                        </a>-->
                        <a ngbDropdownItem class="ff-semibold" (click)="logout()">
                            Logout
                        </a>
                    </div>
                </div>
            <!-- </div> -->
        </div>
    </div>
</div>